
import styles from "./articleTypeSummary.module.scss"

// import ArticleCard from "../../../components/articleCard/articleCard"
// import SectionHeader from "../../../components/sectionHeader/sectionHeader"
import SBEditable from "../../../components/sbEditable/sbEditable"

import { useStoryblokArticles } from "../../../hooks/useStoryblokArticles"


function ArticleTypeSummary({ blok, story_language }) {
  const [articles] = useStoryblokArticles(null,null,null,story_language)

  return (
    <SBEditable blok={blok}>
      {/* <SectionHeader title={blok.headline}>
        <a href="#">All Guides</a>
      </SectionHeader> */}
      <div className={styles.articlelayout}>
        <div>
          {RenderArticle(articles[0])}
          {RenderArticle(articles[1])}
        </div>
        <div>
          {RenderArticle(articles[2])}
          {RenderArticle(articles[3])}
        </div>
        <div>
          {RenderArticle(articles[4])}
          {RenderArticle(articles[5])}
        </div>
      </div>
    </SBEditable>
  )
}

function RenderArticle(article) {
  if(!article) { return }

  return (
    <></>
    // <ArticleCard
    //   headline={article.content.headline}
    //   lead={article.content.lead} />
  )
}

export default ArticleTypeSummary